export const MEDIA_ORDER_SPREAD = 2 ** 10;

export const MEDIA_ORDER_OFFSET = 2;

export const MAX_MEDIA = 20;

export const MAX_SPONSORS = 50;
